// start:ng42.barrel
export * from './upload.component';
// end:ng42.barrel
